// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "changeSet": "10315",
    "buildNumber": "28940",
    "buildJob": "Collect.vNext.UI-Prod",
    "buildAgent": "TFS",
    "buildTime": "10/21/2026 21:05:12"
};
/* tslint:enable */
